import  FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import CreateIcon from "@material-ui/icons/Create";
import React, { useEffect, useState } from 'react'
import "./Sidebar.css";
import SidebarOption from "./SidebarOption";
import InsertCommentIcon from "@material-ui/icons/InsertComment"
import AddIcon from "@material-ui/icons/Add";
import db from './firebase';
import { useStateValue } from './StateProvider';
function Sidebar() {
    const [{user}] = useStateValue();
    const [channels,setChannels] = useState([]);
    useEffect(() => {
        db.collection('Rooms').onSnapshot(snapshot => (setChannels(snapshot.docs.map(doc=>({
            id: doc.id,
            name: doc.data().name
        })))
        
        ))
    }, [])
    
    return (
        
        <div className="sidebar">
            <div className="sidebar__header">
                <div className="sidebar__info">
                <h2>Test Guy</h2>
                <h3><FiberManualRecordIcon />
                {user?.displayName}
                </h3>
                </div>
                <CreateIcon />
                
            </div>
            <SidebarOption Icon={InsertCommentIcon} title="Hello"/>
            <SidebarOption Icon={InsertCommentIcon} title="Hello1"/>
            <SidebarOption Icon={InsertCommentIcon} title="Hello2"/>
            <SidebarOption Icon={InsertCommentIcon} title="Hello3"/>
            <hr/>
            <SidebarOption Icon={AddIcon} addChannelOption title="Add Channel"/>
            {channels.map(channel => (
                
                <SidebarOption title={channel.name} id={channel.id}/>
            ))}
            
        </div>
    )
}

export default Sidebar
